import { Button } from "@mui/material";
import {useRouter} from "next/router";
import {useTranslation} from "@fanfanlo"
export function AddExternalMarketButton(){
    const router = useRouter()
    const {t} = useTranslation('homepage/components/markets/content');
    function onClick(){
        router.push("/add-market")
    }
    return (
        <Button onClick={onClick}>
            {t("AddExternalMarketButton.name")}
        </Button>
    )
}